<template>
  <transition name="slide-fade">
    <div v-if="!isCollapse" class="sidebar">
      <el-menu
        mode="vertical"
        :default-active="activeIndex"
        active-text-color="#ffd04b"
        background-color="#435b60"
        text-color="#fff"
        :router="false"
        :collapse="isCollapse"
        unique-opened
        @select="handleMenuSelect"
        class="sidebar-menu"
      >
        <!-- TOP GROUP: Folder, Quotation, Invoice, Expense -->
        <el-menu-item index="#" style="background-color: #208b8c;">
          <el-icon><img src="@/assets/images/system/folder-icon.svg"></el-icon> &nbsp; &nbsp; &nbsp;
          <span>Folder</span>
        </el-menu-item>

        <el-sub-menu index="1">
          <template #title>
            <span class="prepend"><span class="dot _flamingo"></span></span>
            <span>Quotation</span>
          </template>
          <el-menu-item-group title="">
            <el-menu-item index="/add-quotation"
              ><i class="fas fa-plus-square"></i>&nbsp;&nbsp;&nbsp;&nbsp;New</el-menu-item
            >
            <el-menu-item index="/list-quotation"
              ><i class="fas fa-caret-square-right"></i>&nbsp;&nbsp;&nbsp;&nbsp;View Log</el-menu-item
            >
          </el-menu-item-group>
        </el-sub-menu>

        <el-sub-menu index="2">
          <template #title>
            <span class="prepend"><span class="dot _java"></span></span>
            <span>Invoice</span>
          </template>
          <el-menu-item-group title="">
            <el-menu-item index="/add-invoice"
              ><i class="fas fa-plus-square"></i>&nbsp;&nbsp;&nbsp;&nbsp;New</el-menu-item
            >
            <el-menu-item index="/list-invoice"
              ><i class="fas fa-caret-square-right"></i>&nbsp;&nbsp;&nbsp;&nbsp;View Log</el-menu-item
            >
          </el-menu-item-group>
        </el-sub-menu>

        <el-sub-menu index="3">
          <template #title>
            <span class="prepend"><span class="dot _boston"></span></span>
            <span>Expense</span>
          </template>
          <el-menu-item-group title="">
            <el-menu-item index="/add-expense"
              ><i class="fas fa-plus-square"></i>&nbsp;&nbsp;&nbsp;&nbsp;New</el-menu-item
            >
            <el-menu-item index="/list-expenses"
              ><i class="fas fa-caret-square-right"></i>&nbsp;&nbsp;&nbsp;&nbsp;View Log</el-menu-item
            >
          </el-menu-item-group>
        </el-sub-menu>

        <!-- DIVIDER between top and middle groups -->
        <div class="menu-group-divider"></div>

        <!-- SPACER pushes middle group down from the top group -->
        <div class="menu-group-spacer"></div>

        <!-- MIDDLE GROUP: Item List, Client List, Accountant -->
        <el-menu-item index="/item-list">
          <el-icon><i class="fas fa-tools"></i></el-icon>
          <template #title>&nbsp; Item List</template>
        </el-menu-item>

        <el-menu-item index="/list-clients">
          <el-icon><i class="fas fa-users"></i></el-icon>
          <template #title>&nbsp; Client List</template>
        </el-menu-item>

        <el-menu-item index="#">
          <el-icon><img src="@/assets/images/system/plus-minus.svg"></el-icon> &nbsp;
          <span>Accountant</span>
        </el-menu-item>

        <!-- SPACER pushes bottom group to the bottom -->
        <div class="menu-group-spacer"></div>

        <!-- DIVIDER between middle and bottom groups -->
        <div class="menu-group-divider"></div>

        <!-- BOTTOM GROUP: Notifications, Setting, Subscribe, Download, Rate Us -->
        <el-menu-item index="/notifications">
          <el-icon><i class="fas fa-bell"></i></el-icon>
          <template #title>&nbsp; Notifications</template>
        </el-menu-item>

        <el-menu-item index="/setting">
          <el-icon><img src="@/assets/images/system/settings.png"></el-icon>
          <template #title>&nbsp; Setting</template>
        </el-menu-item>

        <el-menu-item index="/setting?pg=subscription">
          <el-icon><img src="@/assets/images/system/cart.png"></el-icon>
          <template #title>&nbsp; Subscribe</template>
        </el-menu-item>

        <el-menu-item index="https://apps.apple.com/gb/app/smoothbalance-invoice-maker/id1155474274">
          <el-icon><img src="@/assets/images/system/down-arrow.png"></el-icon>
          <template #title>&nbsp; Download</template>
        </el-menu-item>

        <el-menu-item index="#" class="rate-us-item">
          <img src="@/assets/images/system/medal.png" />&nbsp;
          <template #title>Rate Us</template>
        </el-menu-item>
      </el-menu>

      <!-- Element Plus Dialog -->
      <el-dialog v-model="dialogVisible" title="Complete Registration" width="500">
        <span
          >Your registration is not complete. Please complete your registration to
          proceed.</span
        >
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="dialogVisible = false">Cancel</el-button>
            <router-link
              style="display: initial"
              :to="{ name: 'soletrader-limitedcompany' }"
              class="el-button el-button--success"
            >
              Continue to Register
            </router-link>
          </div>
        </template>
      </el-dialog>
    </div>
  </transition>
</template>
<script>

export default {
  name: "AsideMenu",
  data() {
    return {
      dialogVisible: false,
      isProfileComplete: false,
      isCollapse: false,
      activeIndex: "",
    };
  },
  mounted() {
    this.checkProfileStatus();
  },
  methods: {
    collapseToggle() {
      this.isCollapse = !this.isCollapse;
    },
    checkProfileStatus() {
      this.isProfileComplete = this.$store.getters["auth/getProfileCompleteStatus"];
    },
    handleMenuSelect(index) {
      if (!this.isProfileComplete) {
        this.dialogVisible = true;
      } else {
        if (index.startsWith('http://') || index.startsWith('https://')) {
          window.open(index, '_blank');
        } else {
          this.$router.push(index);
        }
      }
    },
  },
};
</script>

<style scoped>
/* Fixed full-screen sidebar — stays locked regardless of page scroll */
.sidebar {
  position: fixed;
  top: 60px; /* offset below the fixed header nav */
  left: 0;
  bottom: 0;
  width: 200px;
  height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  overflow: hidden;
  z-index: 1029; /* just below the top nav affix (1030) */
}

/* The el-menu fills the sidebar height and scrolls independently */
.sidebar-menu {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}

/* Thin scrollbar styling */
.sidebar-menu::-webkit-scrollbar {
  width: 4px;
}
.sidebar-menu::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
}
.sidebar-menu::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.25);
  border-radius: 2px;
}

/* Visual separator between groups */
.menu-group-divider {
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  margin: 4px 0;
}

/* Spacer that grows to fill available space, pushing bottom group down */
.menu-group-spacer {
  flex: 1;
  min-height: 16px;
}
</style>
